exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay{position:absolute;top:0;bottom:0;left:0;right:0;background-color:#fff;background-repeat:no-repeat;background-image:url(/dist/assets/img/icons/user-lock-2.svg);background-position:80% 10px}.error-content{position:relative;max-width:620px;margin:200px auto 0}.error-icon{height:160px;width:160px;background-image:url(/dist/assets/img/icons/user-lock.svg);background-size:cover;background-repeat:no-repeat;margin-right:80px}.error-code{font-size:120px;color:#5c6bc0}body.empty-layout .theme-config,body.empty-layout .to-top{display:none!important}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/forbidden/forbidden.component.css
// module id = ./ClientApp/app/components/forbidden/forbidden.component.css
// module chunks = main